import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Context
import { AuthProvider } from './context/AuthContext';

// Auth guards
import RoleProtectedRoute from './components/RoleProtectedRoute';

// ── Shared ─────────────────────────────────────────────────────────────
import Login from './pages/Login';

// ── Candidate components ────────────────────────────────────────────────
import Registration from './components/user/Registration';
import Events from './components/user/Events';
import LessonViewer from './components/user/LessonViewer';
import LessonCard from './components/user/LessonCard';
import Quiz from './components/user/Quiz';

// ── Admin / Interviewer pages & components ─────────────────────────────
import EventsList from './pages/EventsList';
import EventDetails from './pages/EventDetails';
import CandidatesList from './components/CandidatesList';
import ConsolidatedReport from './components/ConsolidatedReport';
import Category from './pages/Category';
import CategoryDetails from './pages/CategoryDetails';
import ReportDetails from './pages/ReportDetails';
import UserManagement from './pages/UserManagement';
import CandidateDetails from './pages/CandidateDetails';

// ── Layout ─────────────────────────────────────────
import GlobalLayout from './components/GlobalLayout';

// ── Route declarations ──────────────────────────────────────────────────
const AppRoutes = () => (
    <Routes>
        {/* Public routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Registration />} />

        {/* Authenticated routes wrapped with GlobalLayout */}
        <Route element={<GlobalLayout />}>
            {/* Shared admin/interviewer routes */}
            <Route element={<RoleProtectedRoute allowedRoles={['admin', 'interviewer']} />}>
                <Route path="/dashboard" element={<EventsList />} />
                <Route path="/candidates" element={<UserManagement />} />
                <Route path="/user/:id" element={<CandidateDetails />} />
                <Route path="/report/:candidateId/:eventId" element={<ReportDetails />} />
                <Route path="/report-details" element={<ReportDetails />} />
                <Route path="/consolidated/:eventId" element={<ConsolidatedReport />} />
            </Route>

            {/* Admin-only routes */}
            <Route element={<RoleProtectedRoute allowedRoles={['admin']} />}>
                <Route path="/event/:id/:name" element={<EventDetails />} />
                <Route path="/candidates/:id" element={<CandidatesList />} />
                <Route path="/categories" element={<Category />} />
                <Route path="/categories/:id/:name" element={<CategoryDetails />} />
            </Route>

            {/* Candidate routes */}
            <Route element={<RoleProtectedRoute allowedRoles={['candidate']} />}>
                <Route path="/events" element={<Events />} />
                <Route path="/lessons/:eventId" element={<LessonViewer />} />
                <Route path="/lesson/:levelId" element={<LessonCard />} />
                <Route path="/quiz/:eventId" element={<Quiz />} />
            </Route>
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
);


const App = () => (
    <Router>
        <AuthProvider>
            <Toaster
                position="top-right"
                toastOptions={{
                    duration: 4000,
                    style: { fontFamily: 'Red Hat Display, Inter, sans-serif' },
                }}
            />
            <AppRoutes />
        </AuthProvider>
    </Router>
);

export default App;
